
export default {
  hasContent: function(zone) {
    return !!zone?.modules?.filter((module) => {
      return module?.content?.length;
    })?.length;
  },
}